<div class="card box mt-2 px-4 py-3" *ngIf="user$ | async as user">
  <!-- Deine aktuelle Therapie -->
  <h3 class="text-color mt-2 mb-1">{{ 'dashboard.therapy_card.therapy_title' | translate }}</h3>

  <ng-container *ngIf="therapyTypesOf(user).length; else noTherapy">
    <p class="fw-bold mb-2">
      <span *ngFor="let type of therapyTypesOf(user); let last = last"
        >{{ type | cancerTherapyName | translate }}<span *ngIf="!last">, </span></span
      >
    </p>
    <p class="text-muted">{{ 'dashboard.therapy_card.therapy_info' | translate }}</p>

    <!-- one link per therapy type (placeholder link for now) -->
    <div class="row">
      <div class="col-12 col-md-6 mb-3" *ngFor="let type of therapyTypesOf(user)">
        <app-link-preview [url]="infoLink"></app-link-preview>
      </div>
    </div>

    <div class="mb-2">
      <a
        class="btn-link link-small text-primary cursor-pointer"
        (click)="handleChangeTherapyClick()"
      >
        {{ 'dashboard.therapy_card.change_link' | translate }}
      </a>
    </div>
  </ng-container>

  <ng-template #noTherapy>
    <p class="text-muted mb-2">{{ 'dashboard.therapy_card.therapy_empty' | translate }}</p>
    <div class="mb-2">
      <a
        class="btn-link link-small text-primary cursor-pointer"
        (click)="handleChangeTherapyClick()"
      >
        {{ 'dashboard.therapy_card.therapy_empty_cta' | translate }}
      </a>
    </div>
  </ng-template>

  <hr class="w-100" />

  <!-- Art des Tumors (display-only) -->
  <h3 class="text-color mt-2 mb-1">{{ 'dashboard.therapy_card.cancer_title' | translate }}</h3>

  <ng-container *ngIf="cancerTypesOf(user).length; else noCancer">
    <p class="fw-bold mb-2">
      <span *ngFor="let type of cancerTypesOf(user); let last = last"
        >{{ type | cancerTypeName | translate }}<span *ngIf="!last">, </span></span
      >
    </p>
    <p class="text-muted">{{ 'dashboard.therapy_card.cancer_info' | translate }}</p>

    <div class="row">
      <div class="col-12 col-md-6 mb-3">
        <app-link-preview [url]="infoLink"></app-link-preview>
      </div>
    </div>
  </ng-container>

  <ng-template #noCancer>
    <p class="text-muted mb-2">{{ 'dashboard.therapy_card.none' | translate }}</p>
  </ng-template>
</div>
